import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { ArtistPostProfileLanguagesParams } from '@/shared/api/requests/artist/languages/post/request';
import { artistPostProfileLanguages } from '@/shared/api/requests/artist/languages/post/request';

export const useArtistProfileLanguagesMutation = (
  settings?: MutationSettings<
    ArtistPostProfileLanguagesParams,
    typeof artistPostProfileLanguages
  >
) =>
  useMutation({
    mutationKey: ['ArtistProfileLanguages'],
    mutationFn: ({ params, config }) =>
      artistPostProfileLanguages({
        params,
        config
      }),
    ...settings?.options
  });
